export { H1Loader } from './h1-loader';
export type { H1LoaderProps } from './h1-loader';
